export class OnboardingExportToEmp {
  empId: number;
  empCode: number;
  email: string;
  createdBy: string;
  peopleManagerCode: number;
  seniorManagerCode: number;
  groupId: string;
  type: string;
}
